const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    cellphones: {
      type: 'string',
      title: 'افزودن با شماره لیست',
    },
    user_category_id: {
      type: 'string',
      title: 'گروه',
    },
  },
});

export default schema;
